import { BREAKPOINTS } from '../utils/constants';

const initAccordion = () => {
  const mobileOnlyAccordionEls = document.querySelectorAll('[data-mobile-accordion]');
  if (!mobileOnlyAccordionEls.length) return;

  const desktopMediaQuery = window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`);

  const toggleAccordions = () => {
    mobileOnlyAccordionEls.forEach(accordionEl => {
      accordionEl.open = desktopMediaQuery.matches;
    });
  };

  toggleAccordions();
  desktopMediaQuery.addEventListener('change', toggleAccordions);
};

export default initAccordion;
